import React from 'react'
import { useRoutes } from 'react-router-dom';
import Home from './Home';
import Contactus from './Contactus';
import About from './About';
import Services from './Services';
import App from '../App';
import Projects from './Projects';
import WorldTradeCentre from './projects/world-trade-centre';
import MallofMuscat from './projects/MallofMuscat';
import AlilaSalalah from './projects/AlilaSalalah';
import OmanAquarium from './projects/OmanAquarium';
import BaitAlReem from './projects/BaitAlReem';
import HaiAlNaseem from './projects/HaiAlNaseem';
import SoharChinaDowntown from './projects/SoharChinaDowntown';
import AhliBankHead from './projects/AhliBankHead';
import SnowPark from './projects/SnowPark';
import AnantaraResort from './projects/AnantaraResort';
import DusitD2 from './projects/DusitD2';

const RouterIndex = () => {


  const routes = useRoutes([
    {

      element: <App />, // Wrap all routes inside App
      children: [
        { path: "/", element: <Home /> }, // Default route inside IndexLayer
        { path: "/contact_us", element: <Contactus /> },
        { path: "/about_us", element: <About /> },
        { path: "/service/:id", element: <Services /> },
        { path: "/projects", element: <Projects /> },
        { path: "/projects/world-trade-centre", element: <WorldTradeCentre /> },
        { path: "/projects/mall-of-muscat", element: <MallofMuscat /> },
        { path: "/projects/alila-Salalah-Hotel", element: <AlilaSalalah /> },
        { path: "/projects/oman-aquarium-mall-of-muscat", element: <OmanAquarium /> },
        { path: "/projects/bait-al-reem", element: <BaitAlReem /> },
        { path: "/projects/hai-al-naseem", element: <HaiAlNaseem /> },
        { path: "/projects/sohar-china-downtown", element: <SoharChinaDowntown /> },
        { path: "/projects/ahli-bank-head-office-building-wattayah", element: <AhliBankHead /> },
        { path: "/projects/snow-park-mall-of-muscat", element: <SnowPark /> },
        { path: "/projects/anantara-resort-hotel-spa", element: <AnantaraResort /> },
        { path: "/projects/dusit-d2", element: <DusitD2 /> },

      ],
    },
    { path: "*", element: <h1>404 - Page Not Found</h1> },
  ]);
  //   { path: "/", element: <Home /> },
  //   { path: "/contact_us", element: <Contactus /> },
  //   { path: "/about_us", element: <About /> },
  //   { path: "/service/:id", element: <Services /> },
  //   // ...
  // ]);
  return routes;
};
export default RouterIndex